export default {
    state: {
        requisition_id: null,
        errors: {},
        meta: {
            adjustment_id: null,
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'code', sortable: true},
                {key: 'date', label: 'Date', tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', sortable: true},
                {key: 'store', label: 'Store', tdClass: 'text-muted'},
                {key: 'item', label: 'Item', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        form: {
            code: '',
            date: null,
            facility_id: '',
            store_id: '',
            item_id: '',
            notes: '',
        },
    },

    getters: {
        getRequisitionMeta: state => state.meta,

        getRequisitionTableFields: state => state.table.fields,

        getRequisitionForm: state => state.form,

        getRequisitionErrors: state => state.errors,
    },

    mutations: {
        resetRequisitionsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setRequisitions: (state, payload) => {
            state.categories = payload;
        },

        setRequisitionsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setRequisitionForm: state => {
            state.form = {
                code: '',
                date: null,
                facility_id: '',
                store_id: '',
                item_id: '',
                notes: '',
            };

            state.errors = {};
        },

        setRequisitionErrors: (state, payload) => {
            state.errors = payload;
        },
    },

    actions: {
        fetchRequisitions: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const requisition = {
                "data": [
                    {
                        "requisition_id": 1,
                        "label": "Requisition1",
                        "data": {
                            "type": "Requisition",
                            "attributes": {
                                "code": "PRU000001",
                                "date": "12-12-12",
                                "facility": "NB-001 - Cedar Harbor Residence [V-IR] [I-DR]",
                                "store": "1",
                                "item": "i-phone",
                            }
                        },
                        "links": {"self": "requisition\/1"}
                    },
                    {
                        "requisition_id": 2,
                        "label": "Requisition2",
                        "data": {
                            "type": "Requisition",
                            "attributes": {
                                "code": "PRU000002",
                                "date": "17-02-11",
                                "facility": "NB-002 - Meridian House [V-IR] [I-DR]",
                                "store": "u W u",
                                "item": "him-phone",
                            }
                        },
                        "links": {"self": "requisition\/2"}
                    },
                    {
                        "requisition_id": 3,
                        "label": "Requisition3",
                        "data": {
                            "type": "Requisition",
                            "attributes": {
                                "code": "PRU000003",
                                "date": "26-12-12",
                                "facility": "NB-002 - Meridian House [V-IR] [I-DR]",
                                "store": "1",
                                "item": "nokia-3310",
                            }
                        },
                        "links": {"self": "requisition\/3"}
                    },
                ],
                "links": {
                    "self": "\/requisition",
                    "first": "http:\/\/pilot.test\/api\/inventory\/requisitions\/requisition?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/requisitions\/requisition?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/requisitions\/requisition?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/requisitions\/requisition",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setRequisitions', requisition);

                commit('setRequisitionsMeta', requisition.meta);

                resolve(requisition);
            });
        },

        submitRequisition: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setRequisitionErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateRequisition: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.requisition_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setRequisitionErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        fetchEditRequisition: ({state, commit}, requisition_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + requisition_id + '/edit')
                    .then(response => {
                        state.requisition_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        deleteRequisition: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.requisition_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
